// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialMedia_container__BFSkJ"};